export default "__VITE_ASSET__DDgMyuw9__"